/**
 * @module store/getters
 *
 * @version 1.0.0
 * @copyright Kosmos 2018
 */

export default {

};
